import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getTagsData } from 'models/tagsdata'; // Importing function to get tags data

/**
 * TagsView class extends JetView to create a custom view for displaying tags.
 */
export default class TagsView extends JetView {
    /**
     * Configures the layout of the TagsView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for text translation
        return {
            type: 'clean', // Clean layout type
            rows: [
                // Array of UI components
                {
                    template: _('Awarded Badges'), // Header template with localized text
                    type: 'header', // Specifies this component as a header
                    css: 'webix_header chart_header', // CSS class for styling
                },
                {
                    view: 'chart', // Chart component
                    type: 'barH', // Horizontal bar chart type
                    localId: 'chart', // Local identifier for the chart
                    radius: 0, // No rounded corners for bars
                    barWidth: 20, // Width of the bars
                    value: '#number#', // Data field for bar value
                    border: false, // No border around bars
                    padding: {
                        // Padding for the chart
                        top: 0,
                        left: 20,
                        bottom: 40,
                    },
                    xAxis: {
                        // Configuration for the X-axis
                        start: 0, // Starting value
                        end: 32, // Ending value
                        step: 4, // Step size
                        color: '#fff', // Color of the axis labels
                        lineColor: '#EDEFF0', // Color of the axis line
                    },
                    yAxis: {
                        // Configuration for the Y-axis
                        template: '', // Template for Y-axis labels
                        lines: false, // No lines on the Y-axis
                        color: '#EDEFF0', // Color of the Y-axis
                    },
                    color: '#color#', // Data field for bar color
                    legend: {
                        // Configuration for the chart legend
                        template: (obj) => _(obj.tag), // Localized legend template
                        valign: 'middle', // Vertical alignment of the legend
                        align: 'right', // Horizontal alignment of the legend
                        width: 130, // Width of the legend
                        marker: {
                            // Configuration for legend markers
                            type: 'round', // Round marker type
                            width: 7, // Width of the marker
                            height: 8, // Height of the marker
                        },
                    },
                    tooltip: {
                        // Configuration for tooltips
                        template: '#number# clients', // Tooltip template
                    },
                },
            ],
        };
    }

    /**
     * Initializes the TagsView.
     */
    init() {}
}

// FILE DOCUMENTED
